
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 13 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.723 1.843h-.645C3.274 1.843 1 4.137 1 6.94v0C1 9.724 3.256 12 6.038 12v0a5.038 5.038 0 005.038-5.038v-.524","stroke":"#9F9F9F","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M8.5 3h4M10.5 1v4","stroke":"#9F9F9F","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"3.726","cy":"5.047","r":".967","fill":"#9F9F9F"}}),_c('circle',{attrs:{"cx":"8.081","cy":"5.047","r":".967","fill":"#9F9F9F"}}),_c('path',{attrs:{"d":"M9 8H3c.614.79 1.364 2 3 2s2.523-1.421 3-2z","fill":"#9F9F9F","stroke":"#9F9F9F","stroke-width":".5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    